import { render, staticRenderFns } from "./TheHeaderDropdownProfile.vue?vue&type=template&id=196189ce&scoped=true&"
import script from "./TheHeaderDropdownProfile.vue?vue&type=script&lang=js&"
export * from "./TheHeaderDropdownProfile.vue?vue&type=script&lang=js&"
import style0 from "./TheHeaderDropdownProfile.vue?vue&type=style&index=0&id=196189ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196189ce",
  null
  
)

export default component.exports